// removed by extract-text-webpack-plugin
module.exports = {"container":"_1UFfxvA0QT_dA38yqb270n"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Statistics/ChartNoData/ChartNoData.scss
// module id = 1323
// module chunks = 1